import React, { useState } from "react";

import './CategoryList.scss';
import './Dishes.scss';
import useCategorys from "../hooks/useCategorys";
import useDishes from "../hooks/useDishes";
import "@fontsource/playfair-display";

function CategoryList() {
    const listCategorys = useCategorys();
    const [selectedCategoryID, setSelectedCategoruID] = useState(undefined);
    const listDishes = useDishes(selectedCategoryID);
    const [selectedCategoryTitle, setSelectedCategoruTitle] = useState("ВЕСЬ АСОРТИМЕНТ");

    const handleCategoryClick = (categoryID, categoryTitle) => {
        setSelectedCategoruID(categoryID);
        setSelectedCategoruTitle(categoryTitle.toUpperCase());
    };

    return (
        <>
            <div className="category">
                {listCategorys.map((item) => (
                    <button
                        key={item.id}
                        className="category__btn"
                        onClick={() => handleCategoryClick(item.id, item.name)}
                    >
                        <div className="category__item">
                            <img src={item.img} className="category__item-img" />
                            <p className="category__item-subtitle">{item.name}</p>
                        </div>
                    </button>
                ))}
            </div>

            <div className="category__title">{selectedCategoryTitle}</div>

            <div className="dishes">
                {listDishes.map((item) => (
                    <div className="dishes__item" key={item.id}>
                        <img src={item.img} loading="lazy" className="dishes__item-img" alt={item.name} />
                        <p className="dishes__item-subtitle">
                            {item.name}{" "}
                            <span className="dishes__item-subtitle-mini">{item.grams}</span>
                        </p>
                        <p className="dishes__item-ing">{item.ingredients}</p>
                        <p className="dishes__item-price">{item.price} грн</p>
                    </div>
                ))}
            </div>
        </>
    );
}

export default CategoryList;

